import React from 'react';

import styles from './ProbableOfferMark.module.scss';

const ProbableOfferMark = (): JSX.Element => (
  <sup className={styles.mark} data-testid="probable-loan-offer">
    *
  </sup>
);

export default ProbableOfferMark;
